export default __webpack_public_path__ + "static/media/Asset 14.cc403231.png";